import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { BaseComponent } from '../../../core/components/base.component';
import { VasAppFacade } from '../../services/vas-app-facade.service';

@Component({
    selector: 'vas-task-list-button',
    template: `
        <div class="container">
            <button
                ion-button
                icon-only
                clear
                (click)="onClick($event)"
                #tasksButton
            >
                <ion-icon name="clipboard"></ion-icon>
            </button>
            <div class="count" *ngIf="showCount">{{todoCount}}</div>
        </div>

    `
})
export class TaskListButtonComponent extends BaseComponent {

    todoCount: number = 0;
    accountId: string;

    @Input() disabled: boolean = false;
    @ViewChild('tasksButton', {read: ElementRef}) button: ElementRef;

    constructor(
        protected appFacade: VasAppFacade,
        protected navController: NavController
    ) {
        super();
    }

    ngOnInit(): void {

        this.appFacade.objects.task.store.getAll()
            .takeUntil(this.ngUnsubscribe)
            .map(tasks => tasks.filter(task => !task.done).length)
            .subscribe(count => this.todoCount = count);

        this.appFacade.objects.account.store.getActive()
            .takeUntil(this.ngUnsubscribe)
            .map(account => account ? account.id : undefined)
            .subscribe(id => this.accountId = id);
    }

    get showCount(): boolean {
        return this.todoCount > 0;
    }

    onClick($event): void {
        if (this.isEventActionDisallowed($event)) {
            return;
        }

        this.navController.push('TaskListPage', {
            accountId: this.accountId
        });
    }

    protected isEventActionDisallowed($event): boolean {
        const isEventFiredByButton = $event && $event.target === this.button.nativeElement.firstChild;
        return isEventFiredByButton && this.disabled;
    }
}



// WEBPACK FOOTER //
// ./src/vas/modules-shared/task-list-button/task-list-button.component.ts